import ContactUsPage from "../ContactUs/ContactUsPage";

export default [
  {
    name: "contact-us",
    parent: "root",
    url: "/contact-us?issue",
    params: {
      issue: { type: "string", dynamic: true }
    },
    component: ContactUsPage,
    defaultBreadcrumbItems: [{ to: "home", label: "breadcrumb.customers", icon: "home" }, { to: "contact-us", label: "contactUs" }]
  }
];



// WEBPACK FOOTER //
// ./src/components/Router/contactUsStates.js